const $221db3f060dbb602$export$923ea8233b386e99 = `https://info.adapool-europe.com/api/pool-params`;
const $221db3f060dbb602$export$8832bcfeabbfcfc0 = "admin:sqlmk854KjF986kljsdQLK656_HHJD";
const $221db3f060dbb602$export$9bec5134f7f38b3a = 10;


const $0f5d7a213243b50f$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $0f5d7a213243b50f$var$AJAX = async (url)=>{
    const headers = new Headers();
    headers.set("Authorization", "Basic " + btoa((0, $221db3f060dbb602$export$8832bcfeabbfcfc0)));
    const fetchPro = fetch(url, {
        headers: headers
    });
    const res = await Promise.race([
        $0f5d7a213243b50f$var$timeout((0, $221db3f060dbb602$export$9bec5134f7f38b3a)),
        fetchPro
    ]);
    const data = await res.json();
    if (!res.ok) throw new Error(`${data.message || "Error fetching data"} (${res.status})`);
    return data;
};
const $0f5d7a213243b50f$var$widget = async ()=>{
    try {
        const dataPool = await $0f5d7a213243b50f$var$AJAX((0, $221db3f060dbb602$export$923ea8233b386e99));
        // Extraction de la première clé (pool ID) dans cardano_cli_data
        const poolIds = Object.keys(dataPool.cardano_cli_data);
        const poolId = poolIds[0];
        if (!poolId) return;
        const params = dataPool.cardano_cli_data[poolId].poolParams;
        const adastat = dataPool.adastat_data;
        const updateElement = (selector, value, action = "text")=>{
            const el = document.querySelector(selector);
            if (el) {
                if (action === "prepend") {
                    const textNodes = Array.from(el.childNodes).filter((node)=>node.nodeType === Node.TEXT_NODE);
                    textNodes.forEach((node)=>node.remove());
                    el.prepend(value);
                } else if (action === "append") el.append(value);
                else el.textContent = value;
            }
        };
        // Mise à jour via cardano_cli_data
        updateElement("[data-name=pool-id]", poolId, "prepend");
        updateElement("[data-name=pool-owners]", params.spsOwners.length.toString());
        updateElement("[data-name=pool-fees-margin]", (params.spsMargin * 100).toFixed(2).toString() + "%");
        updateElement("[data-name=pool-fees-fixed]", (params.spsCost / 1000000).toString());
        updateElement("[data-name=pool-pledge]", (params.spsPledge / 1000000).toString());
        // Mise à jour via adastat_data
        updateElement("[data-name=pool-delegators]", adastat.delegators.toString());
        updateElement("[data-name=pool-active_stake]", Math.round(parseInt(adastat.active_stake) / 1000000).toString());
        // Valeurs fixes ou non disponibles
        updateElement("[data-name=pool-title]", "ADA Pool Europe");
        updateElement("[data-name=pool-updated]", new Date().toISOString().split("T")[0]);
        updateElement("[data-name=pool-roa-actual]", "N/A");
        updateElement("[data-name=pool-roa-lifetime]", "N/A");
    } catch (err) {
        console.error("Widget error:", err);
    }
};
$0f5d7a213243b50f$var$widget();


//# sourceMappingURL=index.ba42c7a3.js.map
